import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { IButtonDirective, MarketplaceFlagComponent, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { AccountMarketplace } from "@front/m19-api-client";
import { PercentPipe } from "@angular/common";
import { AuthService } from "@front/m19-services";
import { toSignal } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-confirm-dsp-automation",
  template: ` <div class="flex flex-col gap-6 p-4 text-gray-700" *transloco="let t">
    <div class="flex flex-col gap-2 text-sm">
      <div
        [innerHTML]="
          t(messageTranslationKey, {
            accountId: modalData.accountMarketplace.accountId,
            dspAdvertiserName: modalData.accountMarketplace.dspAdvertiser?.name,
          })
        "
      ></div>
      <div class="ml-2 flex flex-wrap items-center gap-3">
        @for (am of modalData.accountMarketplacesWithSameGlobalAdvertiser; track am.marketplace) {
          <div class="flex items-center gap-1">
            <IMarketplaceFlag [marketplace]="am.marketplace"></IMarketplaceFlag>
            <span>{{ am.marketplace }}</span>
          </div>
        }
      </div>
    </div>
    @if (modalData.activatingBidder) {
      <div class="font-medium">
        {{
          t(feeMessageTranslationKey, {
            dspAdSpendFee: modalData.adSpendFee | percent: "1.0-2" : locale(),
          })
        }}
      </div>
    }
    <div class="flex justify-end gap-4">
      <button iButton variant="secondary" (click)="modalRef.close()">
        {{ t("common.cancel") }}
      </button>
      <button iButton (click)="modalRef.close(true)">
        {{ t("common.confirm") }}
      </button>
    </div>
  </div>`,
  imports: [IButtonDirective, MarketplaceFlagComponent, TranslocoDirective, PercentPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDspAutomationModalComponent {
  private readonly authService = inject(AuthService);

  protected readonly modalRef = inject(ModalRef);
  protected readonly modalData = inject<ConfirmDspAutomationModalData>(MODAL_DATA);

  locale = toSignal(this.authService.userLocale$, { requireSync: true });

  messageTranslationKey = this.modalData.activatingBidder
    ? "account-setting.marketplaces_dsp_bidder_on_message"
    : "account-setting.marketplaces_dsp_bidder_off_message";

  feeMessageTranslationKey = dspActivationConfirmMessageKey(this.modalData.onM19Seat);
}

export function dspActivationConfirmMessageKey(onM19Seat: boolean): string {
  return onM19Seat
    ? "account-setting.dsp_m19_seat_activation_confirm_message"
    : "account-setting.dsp_activation_confirm_message";
}

export interface ConfirmDspAutomationModalData {
  accountMarketplace: AccountMarketplace;
  accountMarketplacesWithSameGlobalAdvertiser: AccountMarketplace[];
  adSpendFee: number;
  onM19Seat: boolean;
  activatingBidder: boolean;
}
